/**
 * Switch memoizzato Sì/No
 * @module flyers/components/fields/MemoizedSwitchField
 */

import React from "react";
import { Switch } from "antd";
import FloatingField from "@shared/components/FloatingField.jsx";

/**
 * Campo switch ottimizzato
 */
const MemoizedSwitchField = React.memo(({ fieldKey, label, value, onChange, disabled }) => {
    const handleChange = React.useCallback((checked) => {
        onChange(fieldKey, checked);
    }, [fieldKey, onChange]);

    return (
        <FloatingField label={label}>
            <Switch
                checkedChildren="Sì"
                unCheckedChildren="No"
                checked={Boolean(value)}
                onChange={handleChange}
                disabled={disabled}
            />
        </FloatingField>
    );
}, (prevProps, nextProps) => {
    return (
        prevProps.value === nextProps.value &&
        prevProps.disabled === nextProps.disabled &&
        prevProps.fieldKey === nextProps.fieldKey
    );
});

MemoizedSwitchField.displayName = "MemoizedSwitchField";

export default MemoizedSwitchField;
